import { API_ROUTE_ADMIN_TEXT_TEMPLATES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { TextTemplateTypeOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const getTextTemplateDetails = (id: number) =>
  get<TextTemplateTypeOriginal>(`${API_ROUTE_ADMIN_TEXT_TEMPLATES}/${id}`, IS_NEW_BACKEND_API)
